import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import VisaIcon from '@/core/assets/creditcard-icons/VISA.svg'
import MCIcon from '@/core/assets/creditcard-icons/MC.svg'
import AmexIcon from '@/core/assets/creditcard-icons/AMEX.svg'
import JCBIcon from '@/core/assets/creditcard-icons/JCB.svg'

// Map accepts both short codes (`VISA` / `MC` / `AMEX` / `JCB`) returned by
// detectCardBrand() and long names (`MASTERCARD` / `AMERICAN-EXPRESS`) that
// come from backend payment_options arrays.
const ICON_MAP: Record<string, { src: string; alt: string }> = {
    VISA: { src: VisaIcon, alt: 'Visa' },
    MC: { src: MCIcon, alt: 'Mastercard' },
    MASTERCARD: { src: MCIcon, alt: 'Mastercard' },
    AMEX: { src: AmexIcon, alt: 'American Express' },
    'AMERICAN-EXPRESS': { src: AmexIcon, alt: 'American Express' },
    JCB: { src: JCBIcon, alt: 'JCB' }
}

export interface DynamicCreditCardIconsProps {
    paymentOptions: string | string[]
    height?: number | string
}

export const DynamicCreditCardIcons = ({ paymentOptions, height = 16 }: DynamicCreditCardIconsProps) => {
    const keys = Array.isArray(paymentOptions) ? paymentOptions : [paymentOptions]

    return (
        <Stack direction="row" spacing={1} alignItems="center" data-testid="dynamic-creditcard-icons-stack">
            {keys.map(key => {
                const icon = ICON_MAP[key.toUpperCase()]
                if (!icon) {
                    return (
                        <Typography
                            key={key}
                            variant="caption"
                            fontWeight={700}
                            color="primary"
                            sx={{ px: 0.5 }}
                            data-testid="dynamic-creditcard-icons-typography">
                            {key}
                        </Typography>
                    )
                }
                return <img key={key} src={icon.src} alt={icon.alt} height={height} data-testid="dynamic-creditcard-icons-img" />
            })}
        </Stack>
    )
}
